import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import DivContainer from '../../components/DivContainer';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import moment from 'moment';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import store from '../../store';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import ColorPickerComponent from '../../components/ColorPickerComponent';
import StepperComponent from '../../components/StepperComponent';
import { AddressComponents } from '../../components/locations/LocationsComponent';
import StringUtils from '../../utils/StringUtils';
import SimpleReactValidator from '../../components/validator';
import EventCreateRequest from './EventCreateRequest';
import EventDetailsResponse from './EventDetailsResponse';
import { CustomMessages } from '../../components/CustomMessages';
import EventService from '../../services/EventService';
import Constants from '../../utils/constants';
import { Column, DataTable } from 'primereact';
import LocationsComponentV2 from '../../components/locations/LocationComponentV2';
import InputCalendarRangeComponent2 from '../../components/inputs/InputCalendarRangeComponent2';

class EventDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new EventService());        
        this.editorRef = React.createRef();

        this.state = {
            loadDescription: false,
            disabledMode: false,
            elementId: this.props.elementId,
            locale:store.getState().supportedLocales[0],
            supportedLocales:store.getState().supportedLocales,
            activeIndex: 0,
            element: props.viewMode === 'NEW' ? new EventCreateRequest([], this.props.dateFrom) : new EventDetailsResponse([]),
        };
        this.items = this.getItems();
    }
    getItems = () => {
        const items = [];
        items.push({
            icon: 'pi pi-info-circle',
            label: t('event.baseInfo'),
        })
        items.push({
            icon: 'pi pi-map-marker',
            label: t('event.place'),
        })
        if(this.props.viewMode !== "NEW"){
            items.push({
                icon: 'pi pi-users',
                label: t('event.participants'),
            })
        }    
       return items;
    }
    translate(key) {
        const { t } = this.props;
        return t(key);
    }
    initBeforeSetElement(){
        this.setState({
            element : this.props.viewMode === 'NEW' ? new EventCreateRequest(this.state.supportedLocales, this.props.dateFrom) : new EventDetailsResponse(this.state.supportedLocales)
        })
    }
    updateElement(data) {
        if (this._isMounted) {
            const element =  this.state.element;
            element.supportedLocales = this.state.supportedLocales;
            this.setState(
                {
                    element: EventDetailsResponse.copy(element, data),
                },
                () => this.initAfterSetElement()
            );
        }
    }
    
    initAfterSetElement(){
        super.initAfterSetElement();
        this.setState({loadDescription:true}) 
    }

    renderFooter() {
        const footerItems = this.prepareFooterItems();
        if (footerItems !== undefined && footerItems.length > 0 && footerItems.filter((f) => f.rendered !== false)?.length > 0) {
            return (
                <React.Fragment>
                    <hr className='line-footer-user-dialog' />
                    {this.prepareFooter(footerItems)}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    prepareFooterItems() {
       const items = [];
       const element =  this.state.element;
       if(this.props.viewMode === "EDIT" && StringUtils.isBlank(element.id)){
            return
       }
        const save = 
        {
            label: t('event.dialog.save'),
            className: 'float-right save-btn',
            onClick: this.handleFormSubmit,
        };
        const close = 
        {
            label: t('event.dialog.close'),
            className: 'float-right close-btn',
            onClick: this.props.onHide,
        };
        items.push(close);
        if(!this.isDisable()){
            items.push(save)
        }
        if(this.props.viewMode !== "NEW" && !this.isDisable()){
            const publish =   {
                label: t('event.dialog.publish'),
                className: 'float-right publish-btn',
                onClick: () => this.changeStatus("ACTIVE"),
            }
            items.push(publish)
        }
        if(this.props.viewMode !== "NEW" && this.state.element?.status !== "ACTIVE"){
            items.push({
                label: t('event.dialog.remove'),
                className: 'float-right remove-btn',
                onClick: () => this.changeStatus("REMOVED"),
            })
        }
        return items;
    }
    changeStatus = (status) => {
        const message =status === "ACTIVE" ? t("event.publishMessage") : t("event.deleteMessage");
        this.service.changeStatus(this.state.elementId, status)
        .then(()=>{
            this.persistMessage('success', '', message);
            this.props.afterSave();
        }).catch((err)=>{
            this.showErrorMessage(err.message)
        })
    }
    prepareElementBeforeRequest(element) {
        element.translations = Object.assign({}, element.translations);
        element.start = moment(element.dateRange[0]).format(Constants.DATE_TIME_FORMAT)
        element.end = moment(element.dateRange[1]).format(Constants.DATE_TIME_FORMAT)
        return element;
    }
    createOrUpdate() {
        if(StringUtils.isBlank(this.state.element.longitude)){
            this.showErrorMessage(t("event.noLocationSelected"))
            this.unblockUi();
            return;
        }
        console.log(this.state.element.dateRange);
        if(this.state.element.dateRange === null || this.state.element.dateRange.length!=2 || this.state.element.dateRange[0] === null || this.state.element.dateRange[1] === null){
            this.showErrorMessage(t("event.dateRangeError"))
            this.unblockUi();
            return;
        }
        const element = this.state.element;
        const request = this.prepareElementBeforeRequest(element);
        this.scrollToTop();
        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.props.unblockUi()
                    });
            } else {
                this.service
                    .update(request)
                    .then((response) => {
                        this.afterUpdateSuccess(this.getUpdateSucces(response));
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.props.unblockUi()
                    });
            }
        }
    }
    renderHeader() {
        const { t } = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{t('event.dialog.title')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    getContainerListName() {
        return 'event-list';
    }

    getAddSucces() {
        return t('event.addSuccess');
    }
    getUpdateSucces() {
        return t('event.updateSuccess');
    }
    getLocations = () => {
        if(StringUtils.isBlank(this.state.element.longitude) ){
            return [];
        }
        const locations = [{
            longitude:this.state.element.longitude,
            latitude : this.state.element.latitude,
            localizationTolerance : this.state.element.localizationTolerance,
        }];
        return locations;
    }

    isDisable = () => {
        let reulstOfEndDate = false;
        if(!StringUtils.isBlank(this.state.element?.end) && this.props.viewMode === "EDIT"){
           const currentEnd = new Date(this.state.element?.end);
           reulstOfEndDate = currentEnd < new Date();
        }
        const res = this.state.element?.status === "ACTIVE";
        return res; 
    }
    creatorName =()=>{
        const {creator} = this.state.element;
        return creator?.firstName + " " + creator?.lastName + " - "+ creator?.email;
    }

    renderDetails() {
        return (
            <div className='row'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <div className='col-12'>
                    <div className='row'>
                        <div className='col-2'>
                            <InputLanguageDropdownComponent
                                id='locale'
                                name='locale'
                                label={t('global.languageChooser')}
                                validator={this.validator}
                                validators='not_required'
                                colClass=""
                                value={this.state.locale}
                                options={this.state.supportedLocales}
                                insideTable
                                viewMode={'EDIT'}
                                onChange={this.handleChange}
                                rendered
                                showClear={false}
                                stateField={``}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-12 '></div>
                <StepperComponent 
                  validation={(fnc)=>{
                    if (this.validator.allValid()) {
                        fnc();
                    } else {
                        this.validator.showMessages();
                        this.scrollToError = true;
                        this.forceUpdate();
                    }
                  }}
                  outsideClassName
                  stepClassName={"mb-2 mt-2"}
                  model={this.items}
                  components={[
                    <div className='row'>
                        <ColorPickerComponent              
                            label={t('event.background')} 
                            viewMode={this.isDisable() ? "VIEW" : "EDIT"} 
                            value= {this.state.element?.background?.value}
                            onChange={(e)=>{
                                this.setState((prevState)=>({
                                    element:{
                                        ...prevState.element,
                                        background:{value: e.value}
                                    }
                                }))
                            }}
                        />
                        <InputTextComponent  
                            id='creator'
                            name='creator'
                            label={t('event.creator')}
                            colClass='col-12'
                            disabled={this.isDisable()}
                            value={this.creatorName()}
                            validator={this.validator}
                            validators='required|max:100'
                            onChange={this.handleChange}
                            viewMode={"VIEW"}
                            rendered={this.props.viewMode==="EDIT" }
                            stateField={`element.translations[${this.state.locale}]`}/>
                        <InputTextComponent
                            id='title'
                            name='title'                            
                            disabled={this.isDisable()}
                            label={t('event.title')}
                            colClass='col-6'
                            value={this.state.element?.translations[this.state.locale]?.title}
                            validator={this.validator}
                            validators='required|max:100'
                            onChange={this.handleChange}
                            viewMode={"EDIT"}
                            stateField={`element.translations[${this.state.locale}]`}
                        />
                        <InputCalendarRangeComponent2
                            id="start-end"
                            name={'dateRange'}
                            label={t('event.dateRange')}              
                            disabled={this.isDisable()}
                            colClass='col-4'
                            value={this.state.element.dateRange}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            showTime
                            showIcon                            
                            placeholder='dd-mm-rrrr GG:MM - dd-mm-rrrr GG:MM'                            
                            validateViewMode
                            dateFormatMoment='DD-MM-YYYY HH:mm'
                            
                        />
                    {this.state.loadDescription &&  <InputTextEditorComponent
                            editorRef={this.editorRef}
                            locale={this.state.locale}
                            colClass='col-xl-12'
                            id='description'
                            key={`description-${this.props.viewMode}`}
                            name='description'
                            value={this.state.element?.translations[this.state.locale]?.description}
                            label={t('quiz.description')}
                            validator={this.validator}
                            validators='required'             
                            disabled={this.isDisable()}
                            rows='5'
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            autoResize
                            externalPhotos={true}
                            photoUrl={``}
                            photoLabel='fileName'
                            photoName='uuid'
                            handleError={this.onUploladError}
                            restrictExt={false}
                            token={this.authService.getToken()}
                            photoVarName='photos'
                            stateField={`element.translations[${this.state.locale}]`}
                        />}
                       
                    </div>,
                    <div className='row'>
                        <LocationsComponentV2
                            addressInfoComponents= {[
                                AddressComponents.CITY, 
                                AddressComponents.STREET_NAME,
                                AddressComponents.POSTAL_CODE, 
                                AddressComponents.STREET_NUMBER
                            ]}
                            style= {{height: '460px', zIndex: '100'}}
                            initLocation={[52.137, 19.317]} 
                            locations={this.getLocations()}
                            singleLocation
                            onAddLocation={(location) => {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        longitude:location.longitude,
                                        latitude:location.latitude,
                                        localizationTolerance:location.localizationTolerance
                                    },
                                }));
                            }}
                            validator={new SimpleReactValidator({}, this.translate)}
                            onUpdateLocation={(locations) => {
                                const location = locations[0];
                                if(StringUtils.isBlank(location)){
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            longitude:undefined,
                                            latitude:undefined,
                                            localizationTolerance:undefined
                                        },
                                    }));
                                    return;
                                }
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        longitude:location.longitude,
                                        latitude:location.latitude,
                                        localizationTolerance:location.localizationTolerance
                                    },
                                }));
                            }}
                            viewMode={this.isDisable() ? "VIEW" :  this.props.viewMode} 
                            showErrorMessage={this.showErrorMessage} 
                            showSuccessMessage={this.showSuccessMessage}
                        />
                    </div>,
                    <div>
                          <DataTable
                                emptyMessage={t('list.empty')}
                                value={this.state.element.participants}
                                sortField='email'
                                removableSort
                                tableStyle={{minWidth: '50rem'}}
                                paginator
                                rows={25}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                            >
                                <Column sortable field='email' header={t('user.email')}></Column>
                                <Column sortable field='firstName' header={t('user.firstName')}></Column>
                                <Column sortable field='lastName' header={t('user.lastName')}></Column>
                                <Column sortable field='name' header={t('user.name')}></Column>
                            </DataTable>
                    </div>
                  ]}
                />
            </div>
        );
    }
}

EventDialog.defaultProps = {
    visible: false,
};

EventDialog.propTypes = {
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    dateFrom: PropTypes.any
};

export default withTranslation()(EventDialog);
